import React, {useEffect, useState} from "react";
import {AchievementsList} from "./Achievements.styles";
import Achievement from "./Achievement/Achievement";
import SubsectionBlock from "../../components/section-items/SubsectionBlock/SubsectionBlock";
import SubsectionTitle from "../../components/section-items/SubsectionTitle/SubsectionTitle";
import SubsectionText from "../../components/section-items/SubsectionText/SubsectionText";
import {fetchData} from "../../helpers/fetchData";
import {MatchesInfoText} from "../Matches/Matches.styles";
import LoadingSpinner from "../../components/spinners/LoadingSpinner";

const Achievements = () => {

    const [achievements, setAchievements] = useState([]);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        fetchData('tournaments/achievements')
            .then(res => setAchievements(res))
            .then(() => setIsFetching(false))
            .catch(e => console.error(e));
    }, []);

    const renderAchievements = () => {
        return achievements.map((e, index) =>
            <Achievement key={e.id + index} place={e.place} venue={e.venue} name={e.name} date={e.end_date}/>
        );
    };

    return (<SubsectionBlock id={'achievements'}>
        <SubsectionTitle color={'#006400'}>{'Największe osiągnięcia zespołu'}</SubsectionTitle>
        <SubsectionText>{'Zawsze staramy się dążyć do doskonałości oraz zdobywać kolejne puchary. Od zawsze naszym marzeniem jest przystąpienie do rozgrywek B Klasy. Nie zwalniamy tempa by kiedyś tego dokonać!'}</SubsectionText>
        <AchievementsList>
            {isFetching ? <LoadingSpinner/> : (!isFetching && achievements.length) ? renderAchievements() : <MatchesInfoText>{'Brak danych do wyświetlenia.'}</MatchesInfoText>}
        </AchievementsList>
    </SubsectionBlock>);
};

export default Achievements;
